<template>
	<vx-card>
		<vs-popup
			:active.sync="showValidateTaskTablePopup"
			title="Veuillez vérifier les tâches de ce contrat avant de le terminer."
			button-close-hidden
		>
			<ValidateTaskTable
				v-if="showValidateTaskTablePopup"
				:tasks="task"
				:apiUrl="apiUrl"
				:contractId="$route.params.contractId"
			/>
			<div class="vx-row">
				<div class="vx-col w-1/2">
					<vs-button
						color="danger"
						class="mt-2 w-full"
						@click="declineTaskValidate()"
						>Annuler</vs-button
					>
				</div>
				<div class="vx-col w-1/2">
					<vs-button
						color="primary"
						class="mt-2 w-full"
						@click="acceptTaskValidate()"
						>Confirmer</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			:active.sync="showStatusValidationPopup"
			title="Êtes-vous sûr de vouloir passer le statut du contrat en terminé ?"
			button-close-hidden
		>
			<div class="vx-row justify-center">
				<p class="vx-col">
					Cette action passera toutes les missions au statut terminé et les
					actualisera après la validation finale.
				</p>
			</div>
			<div class="vx-row justify-center">
				<p class="vx-col">Cette action est IRRÉVERSIBLE.</p>
			</div>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="acceptTerminationStatus()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="declineTerminationStatus()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir supprimer cette mission ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="acceptDeleteMission()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="declineDeleteMission()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-button
			class="float-right"
			radius
			color="primary"
			type="filled"
			icon-pack="feather"
			icon="icon-x"
			@click="returnPrevRoute"
		></vs-button>
		<form-wizard
			ref="formwizard"
			color="rgba(var(--vs-primary), 1)"
			title="Modification d'un contrat"
			:subtitle="'Modifiez le contrat N°' + $route.params.contractId"
			nextButtonText="Suivant"
			backButtonText="Retour"
			finishButtonText="Enregistrer"
			:start-index="$route.params.startIndex"
		>
			<div class="mb-5">
				<!-- tab 1 content -->
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2"></div>
				</div>
				<div class="vx-row mt-4">
					<!-- SOCIETY -->
					<div class="vx-col sm:w-1/2 w-full mb-2" style="white-space: nowrap">
						<vx-input-group class="bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon
									></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									v-model="contract.society_id"
									:style="styleValidator('society_id')"
									class="w-full select-medium mr-2"
									placeholder="Societé"
									@change="validateOne(contract.society_id, 'society_id')"
									autocomplete
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.name"
										v-for="(item, index) in societyOptions"
										class="w-full"
									/>
								</vs-select>
								<template slot="append">
									<div
										v-if="contract.society_id !== null"
										class="append-text bg-primary"
									>
										<span class="flex">
											<vs-button @click="showSocietyPopup">Détails</vs-button>
										</span>
									</div>
								</template>
								<vx-tooltip
									v-if="
										validators['society_id'] &&
										validators['society_id'].errText !== ''
									"
									:text="errText('society_id')"
									class="ml-3"
									style="display: inline-block; align-self: self-end"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /SOCIETY -->
					<!-- COMMERCIAL -->
					<div
						class="vx-col sm:w-1/4 w-full mb-2 flex"
						style="white-space: nowrap"
					>
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="person_add" size="small"></vs-icon
									></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									v-model="commercialId"
									:style="styleValidator('commercial_id')"
									class="w-full select-medium mr-2"
									placeholder="Commercial Rankwell"
									@change="validateOne(commercialId, 'commercial_id')"
									autocomplete
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.firstname + ' ' + item.lastname"
										v-for="(item, index) in commercialOptions"
										class="w-full"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['commercial_id'] &&
										validators['commercial_id'].errText !== ''
									"
									:text="errText('commercial_id')"
									class="ml-3"
									style="display: inline-block; align-self: self-end"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /COMMERCIAL -->
					<!-- STATUT -->
					<div
						class="vx-col sm:w-1/4 w-full mb-2 flex"
						v-if="$acl.check('sadmin')"
					>
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex">Statut</span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="statusIndex"
								class="w-full select-medium mr-2"
								placeholder="Statut"
							>
								<vs-select-item
									:key="index"
									:value="item.index"
									:text="item.text"
									v-for="(item, index) in sAdminStatusOptions"
									class="w-full"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<div
						class="vx-col sm:w-1/4 w-full mb-2 flex"
						v-else-if="
							$acl.check('admin') &&
							contract.status !== 5 &&
							contract.status !== 4
						"
					>
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex">Statut</span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="statusIndex"
								class="w-full select-medium mr-2"
								placeholder="Statut"
							>
								<vs-select-item
									:key="index"
									:value="item.index"
									:text="item.text"
									v-for="(item, index) in adminStatusOptions"
									class="w-full"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<div class="vx-col sm:w-1/4 w-full mb-2 flex" v-else>
						<vs-chip
							style="width: 80px"
							:color="getContractCurrentStatusColor(statusIndex)"
							>{{ getContractCurrentStatus(statusIndex) }}
						</vs-chip>
					</div>
					<!-- /STATUT -->
				</div>
				<div class="vx-row">
					<!-- PRESTATION -->
					<div class="vx-col sm:w-1/4 w-full mb-2" style="white-space: nowrap">
						<label for="" class="vs-select--label">Prestation</label>
						<div style="display: flex">
							<vs-select
								autocomplete
								:style="styleValidator('delivery')"
								:disabled="missionsAdded > 0"
								v-model="contract.delivery"
								@change="validateOne(contract.delivery, 'delivery')"
								class="w-full select-medium mr-2"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in products_categories"
									class="w-full"
								/>
							</vs-select>
							<vx-tooltip
								v-if="
									validators['delivery'] &&
									validators['delivery'].errText !== ''
								"
								:text="errText('delivery')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<div
						class="vx-col sm:w-1/4 w-full mb-2"
						style="display: inline-table; white-space: nowrap"
					>
						<label for="" class="vs-select--label"
							>Durée d'engagement (mois)</label
						>
						<div style="display: flex">
							<vs-input
								v-model="contract.engagement_duration"
								:style="styleValidator('engagement_duration')"
								@change="
									validateOne(
										contract.engagement_duration,
										'engagement_duration'
									)
								"
							/>
							<vx-tooltip
								v-if="
									validators['engagement_duration'] &&
									validators['engagement_duration'].errText !== ''
								"
								:text="errText('engagement_duration')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<div
						class="vx-col sm:w-1/4 w-full mb-2"
						v-if="contract.engagement_duration > 0"
						style="
							display: inline-table;
							white-space: nowrap;
							align-self: center;
						"
					>
						<vs-checkbox
							class="inline-flex mt-4"
							v-model="contract.early_cancellation"
						>
							<span>Porte de sortie possible</span>
						</vs-checkbox>
					</div>
					<div
						class="vx-col sm:w-1/4 w-full mb-2"
						v-if="
							contract.early_cancellation && contract.engagement_duration > 0
						"
						style="white-space: nowrap"
					>
						<label for="" class="vs-select--label"
							>Durée avant période de sortie (mois)</label
						>
						<div style="display: flex">
							<vs-input
								v-model="contract.early_cancellation_duration"
								:style="styleValidator('early_cancellation_duration')"
								@change="
									validateOne(
										contract.early_cancellation_duration,
										'early_cancellation_duration'
									)
								"
							/>
							<vx-tooltip
								v-if="
									validators['early_cancellation_duration'] &&
									validators['early_cancellation_duration'].errText !== ''
								"
								:text="errText('early_cancellation_duration')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<!-- /PRESTATION -->
				</div>
				<div class="vx-row">
					<!-- COMMENTAIRE DE LA PRESTATION -->
					<div class="vx-col sm:w-full w-full mb-2" style="white-space: nowrap">
						<div style="display: flex">
							<vs-input
								class="w-full"
								label-placeholder="Commentaire"
								v-model="contract.detail"
								:style="styleValidator('detail')"
								@change="validateOne(contract.detail, 'detail')"
							/>
							<vx-tooltip
								v-if="
									validators['detail'] && validators['detail'].errText !== ''
								"
								:text="errText('detail')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<!-- /COMMENTAIRE DE LA PRESTATION -->
				</div>
				<div class="vx-row">
					<!-- COMMENTAIRE FACTURATION -->
					<div class="vx-col sm:w-full w-full mb-2" style="white-space: nowrap">
						<div style="display: flex">
							<vs-input
								class="w-full"
								label-placeholder="Commentaire facturation"
								v-model="contract.commentary"
								:style="styleValidator('commentary')"
								@change="validateOne(contract.commentary, 'commentary')"
							/>
							<vx-tooltip
								v-if="
									validators['commentary'] &&
									validators['commentary'].errText !== ''
								"
								:text="errText('commentary')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<!-- /COMMENTAIRE FACTURATION -->
				</div>
				<div class="vx-row center_div t-border">
					<vs-table
						:data="accountmanagerList"
						v-if="accountmanagerList"
						v-model="lead_account_manager"
						noDataText="Aucun(e) Consultant Lead sélectionné(e)."
						:key="refreshList"
					>
						<template slot="thead">
							<vs-th>Consultant Lead</vs-th>
							<!-- Madame ou Monsieur -->
							<vs-th>Sélectionnez un(e) Consultant Lead en l'ajoutant.</vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr
								:data="data[indextr]"
								:key="indextr"
								v-for="(tr, indextr) in data"
							>
								<vs-td v-if="tr.is_lead && tr.is_lead == 1">{{
									data[indextr].firstname + " " + data[indextr].lastname
								}}</vs-td>
								<!-- Madame ou Monsieur -->
								<!--<vs-td v-if="lead_account_manager == data[indextr]"><vs-button @click="deleteAccountManagerLead(data[indextr].id)" class="mx-2">Supprimer</vs-button><span>Lead</span></vs-td>-->
								<vs-td v-if="tr.is_lead && tr.is_lead == 1"
									><vs-button @click="deleteAccountManager(data[indextr].id)"
										>Supprimer</vs-button
									></vs-td
								>
							</vs-tr>
						</template>
					</vs-table>
					<!-- </div>
          <div class="vx-row center_div t-border"> -->
					<!-- ACCOUNT MANAGER -->
					<div class="vx-col sm:w-1/2 w-full mb-2 flex">
						<vx-input-group class="w-full bottom">
							<!-- <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span class="flex"
                    ><vs-icon icon="person_add" size="small"></vs-icon
                  ></span>
                </div>
              </template> -->
							<vs-select
								v-model="selectedAccountManager"
								class="w-full select-medium mr-2"
								placeholder="Consultant Lead"
								autocomplete
							>
								<vs-select-item
									:key="index"
									:value="item"
									:text="item.firstname + ' ' + item.lastname"
									v-for="(item, index) in accountmanagerOptions"
									class="w-full"
								/>
							</vs-select>
							<vs-button
								class="mt-2"
								@click="addAccountManager(selectedAccountManager)"
								>Ajouter</vs-button
							>
						</vx-input-group>
					</div>
					<!-- /ACCOUNT MANAGER -->
				</div>
			</div>

			<!-- CONTROL UI FOOTER BUTTON -->
			<template slot="footer" slot-scope="props">
				<div class="wizard-footer-left">
					<wizard-button
						v-if="props.activeTabIndex > 0 && !props.isLastStep"
						@click.native="props.prevTab()"
						:style="props.fillButtonStyle"
						>Previous</wizard-button
					>
				</div>
				<div class="wizard-footer-right">
					<wizard-button
						@click.native="showTaskValidationPopup"
						class="wizard-footer-right"
						:style="props.fillButtonStyle"
						>Enregistrer</wizard-button
					>
				</div>
			</template>
		</form-wizard>
	</vx-card>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import store from "@/store/store";

import utilsMixin from "@/mixins/utilsMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import validatorMixin from "@/mixins/validatorMixin";
import Validator from "@/entities/Validator";
import ValidateTaskTable from "@/components/tables/ValidateTaskTable";

import Contract from "@/entities/Contract";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import Mission from "@/entities/Mission";
import MissionForContract from "../mission/MissionForContract";
import ContractSocietyInfoPopup from "@/components/popups/ContractSocietyInfoPopup";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

import vueFilePond from "vue-filepond";

// Import Filepond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";

// Import Filepond styles
import "filepond/dist/filepond.min.css";
// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
	name: "UpdateContractForm",
	mixins: [utilsMixin, dbFieldConvertor, validatorMixin],
	components: {
		FormWizard,
		TabContent,
		WizardButton,
		VxTooltip,
		ValidateTaskTable,
	},
	data() {
		return {
			contractId: null,
			contractMissions: [],
			missionsAdded: 0,
			clickAddMission: false,
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			commercialOptions: [],
			accountmanagerOptions: [],
			contractOptions: [
				{ text: "Mensuel", value: 1 },
				{ text: "One\u00a0Shot", value: 0 },
			],
			adminStatusOptions: [
				{ text: "Actif", index: 1, value: [1, 0] },
				{ text: "A\u00a0Valider", index: 2, value: [2, 0] },
				{ text: "En\u00a0pause", index: 3, value: [3, 0] },
				{ text: "Annulé", index: 5, value: [5, 0] },
			],
			sAdminStatusOptions: [
				{ text: "Actif", index: 1, value: [1, 0] },
				{ text: "A\u00a0Valider", index: 2, value: [2, 0] },
				{ text: "En\u00a0pause", index: 3, value: [3, 0] },
				{ text: "Annulé", index: 5, value: [5, 0] },
				{ text: "Terminé (Impayé)", index: 4, value: [4, 7] },
				{ text: "Terminé (Insatisfaction client)", index: 41, value: [4, 1] },
				{ text: "Terminé (Manque de résultat)", index: 42, value: [4, 2] },
				{ text: "Terminé (Manque de budget)", index: 43, value: [4, 3] },
				{ text: "Terminé (Prestation livrée)", index: 44, value: [4, 4] },
				{ text: "Terminé (Fin de contrat)", index: 45, value: [4, 5] },
				{ text: "Terminé (Autre)", index: 46, value: [4, 6] },
			],
			// DATE PICKER CONFIG
			configFromDatePicker: {
				minDate: new Date(),
			},
			// Validator Objects
			ContractValidationObjects: {
				bccgvValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: false,
				},
				estimateLinkValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: false,
				},
			},
			// FORM FIELDS
			contract: Contract.getFormFields(),
			contractOld: Contract.getFormFields(),
			commercialId: null,
			selectedAccountManager: null,
			accountmanagerList: [],
			productOptions: [],
			lead_account_manager: [],
			lead_account_manager_On: false,
			selectedSociety: null,
			showSocietyPopupActive: false,
			showValidationPopup: false,
			showStatusValidationPopup: false,
			showValidateTaskTablePopup: false,
			missionToDelete: null,
			bccgvToUpdate: null,
			previous_status: null,
			current_status: null,
			statusIndex: null,
			validators: {},
			check: true,
			checkPage: false,
			task: [],
			refreshList: 0,
		};
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	mounted() {
		this.$http
			.get(this.apiUrl + "contract/get/" + this.contractId)
			.then((contract) => {
				//console.log(contract);
				this.contract = new Contract(contract.data[0]);
				this.current_status = [
					this.contract.status,
					this.contract.termination_reason_id,
				];
				let foundStatus = this.sAdminStatusOptions.find(
					(row) =>
						row.value[0] == this.contract.status &&
						row.value[1] == this.contract.termination_reason_id
				);
				this.statusIndex = foundStatus ? foundStatus.index : null;
				this.previous_status = [
					this.contract.status,
					this.contract.termination_reason_id,
				];
				this.contractOld = new Contract(contract.data[0]);
				this.contract.account_managers = [];
				this.contractOld.account_managers = [];
				this.getContractMission(this.contract.id);
				Contract.getRankwellforContract(contract.data[0].id, (err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							for (let collaborator of res.data) {
								if (collaborator.type == 0) {
									this.contract.commercial_id = collaborator.users_id;
									this.commercialId = collaborator.users_id;
								} else {
									//ADD collaborator.is_lead
									let addedCollaborator = this.accountmanagerOptions.find(
										(accountmanager) =>
											accountmanager.id == collaborator.users_id
									);
									addedCollaborator.is_lead = collaborator.is_lead;
									this.contract.account_managers.push(addedCollaborator);
									let addedCollaboratorOld = Object.assign(
										{},
										addedCollaborator
									);
									this.contractOld.account_managers.push(addedCollaboratorOld);
									this.accountmanagerList.push(addedCollaborator);
								}
							}
							for (let account_manager of this.contract.account_managers) {
								if (account_manager.is_lead == 1) {
									//console.log(account_manager);
									this.lead_account_manager = account_manager;
									this.lead_account_manager_On = true;
								}
							}
						}
				});

				// this.providerTempOptionsOld = this.getServiceFromProvider(this.$route.params.providerId)
			})
			.catch((err) => {
				//console.log(err);
			});
	},
	computed: {
		societyOptions() {
			return store.state.societies;
		},
		products_categories: () => {
			return store.state.products_categories;
		},
		activeUser() {
			return VueCookies.get("userInfo");
		},
	},
	watch: {
		/*
		 * contract: function(data){
		 * 	if(data.early_cancellation > 0) this.earlyCancellation = true;
		 * },
		 */
		/*
		 * earlyCancellation: function(data){
		 * 	if(!data) {
		 * 		this.contract.early_cancellation = null;
		 * 		this.contract.early_cancellation_duration = null;
		 * 	}
		 * },
		 */
		/**
		 * Once the user add a mission
		 * Refresh data by getting all the missions for the current contract
		 */
		missionsAdded: function () {
			//console.log("missionAdded called");
			this.getContractMission(this.contract.id);
		},

		statusIndex: function (data) {
			let foundStatus = this.sAdminStatusOptions.find(
				(row) => row.index == data
			);
			this.current_status = foundStatus ? foundStatus.value : [0, 0];
		},

		/*
		 * current_status: function(){
		 *   this.showStatusValidationPopup = this.current_status == 4 ? true : false;
		 * }
		 */
	},

	created() {
		this.getAllSocieties();
		this.getAllCommercials();
		this.getAllAccountManagers();
		this.getAllProducts();
		this.getAllProductsCategories();
		this.contractId = this.$route.params.contractId;
	},
	methods: {
		getStatus(statusIndex) {
			let foundStatus = this.sAdminStatusOptions.find(
				(row) => row.index == statusIndex
			);
			let status = 0;
			if (foundStatus) status = foundStatus.value[0];
			return status;
		},

		getContractCurrentStatusColor(statusIndex) {
			let status = this.getStatus(statusIndex);
			return this.getContractStatusColor(statusIndex);
		},

		getContractCurrentStatus(statusIndex) {
			let status = this.getStatus(statusIndex);
			return this.getContractStatus(status);
		},

		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},
		/**
		 * Query our API to fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocietiesIdAndName");
		},

		/**
		 * Query our API to fetch all the commercials
		 */
		getAllCommercials() {
			this.$http
				.get(this.apiUrl + "users/all/rankwell")
				.then((res) => {
					this.commercialOptions = this.sortABC(
						res.data.filter((collaborator) =>
							[4, 6, 9].includes(collaborator.type)
						),
						"firstname"
					);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Query our API to fetch all the commercials
		 */
		getAllAccountManagers() {
			this.$http
				.get(this.apiUrl + "users/all/accountmanager")
				.then((res) => {
					this.accountmanagerOptions = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Query our API to fetch all products
		 */
		getAllProducts() {
			this.$http
				.get(this.apiUrl + "product/all/")
				.then((res) => {
					this.productOptions = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		getInfo(type, val) {
			if (type == "price") {
				if (val == "" || val == 0 || val == "0" || val == "null" || val == null)
					return "0 €";
				else return val + " €";
			} else if (type == "timeLimit") {
				if (val == "" || val == 0 || val == "0" || val == "null" || val == null)
					return "";
				else return val + " h";
			} else {
				if (val == "" || val == 0 || val == "0" || val == "null" || val == null)
					return "";
				else return val;
			}
		},

		/**
		 * Returns product's name from product's id
		 */
		getProductName(product_id) {
			let product_name = "";
			let product_name_object = this.productOptions.find(
				(product) => product.id == product_id
			);
			product_name = product_name_object.perform;
			return product_name;
		},

		/**
		 * Query our api to fetch all the mission linked to a contract
		 */
		getContractMission(contractId) {
			//console.log("getContractMission");
			this.$http
				.get(this.apiUrl + "mission/get/contract/" + contractId)
				.then((res) => {
					//console.log(res);
					this.contractMissions = res.data;
					this.missionsAdded = this.contractMissions.length;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Création et affichage du popup de création de mission
		 */
		displayMissionForContract(isEdit, mission = null) {
			//Initialisation des données pour le popup
			if (mission !== null) {
				let re = new RegExp("([T|Z])", "g");
				if (mission.start_date)
					mission.start_date = mission.start_date.replace(re, " ");
				if (mission.end_date)
					mission.end_date = mission.end_date.replace(re, " ");
			}
			this.clickAddMission = true;
			let propsData = isEdit
				? {
						propsData: {
							contract: this.contract,
							missionToModify: mission,
							show: this.clickAddMission,
							apiUrl: this.apiUrl,
							router: this.$router,
							editMode: isEdit,
							editContract: true,
						},
				  }
				: {
						propsData: {
							contract: this.contract,
							show: this.clickAddMission,
							apiUrl: this.apiUrl,
							router: this.$router,
							editMode: isEdit,
							editContract: true,
						},
				  };

			//console.log("isEdit", isEdit);
			//console.log("propsData", propsData);
			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(MissionForContract);
			//console.log("ComponentClass");
			//console.log(ComponentClass);
			let missionPopup = new ComponentClass(propsData);
			missionPopup.$mount();
			missionPopup.$on("close-form", () => {
				this.closeMissionForm();
			});
			missionPopup.$on("close-form-after-added", (event) => {
				this.refreshData(event);
			});
			//console.log("missionPopup");
			//console.log(missionPopup);
			this.$refs.popupContainer.appendChild(missionPopup.$el);
			//console.log("this.$refs.popupContainer");
			//console.log(this.$refs.popupContainer);
		},

		updateMission(mission) {
			if (this.contract.status == 4) {
				this.$vs.notify({
					title: "Echec",
					text: "Vous ne pouvez pas modifier les missions d'un contrat terminé.",
				});
			} else {
				this.displayMissionForContract(true, mission);
				//console.log("mission", mission);
				//console.log("updateMission called");
			}
		},

		deleteMission(missionId) {
			//console.log("missionId", missionId);
			//console.log("deleteMission called");
			Mission.delete(missionId, this.activeUser.id, (err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						//console.log(res);
						this.missionsAdded -= 1;
					}
			});
		},

		showDeletePopup(missionId) {
			this.missionToDelete = missionId;
			this.showValidationPopup = true;
		},

		acceptDeleteMission() {
			this.deleteMission(this.missionToDelete);
			this.showValidationPopup = false;
		},

		declineDeleteMission() {
			this.missionToDelete = null;
			this.showValidationPopup = false;
		},

		getAllTasksforContract(contract_id) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "task/getRunningTasksforContract/" + contract_id)
					.then((result) => {
						this.task = result.data;
						//console.log(result.data);
						resolve(result.data);
					})
					.catch((error) => {
						//console.log(error);
						reject(error);
					});
			});
		},

		async showTaskValidationPopup() {
			if (this.current_status[0] == 4) {
				let tasks = await this.getAllTasksforContract(this.contractId);
				if (tasks.length > 0) {
					this.showValidateTaskTablePopup = true;
				} else {
					this.acceptTaskValidate();
				}
			} else {
				this.saveContract();
				return true;
			}
		},

		terminateAllMissions() {
			/*
			 * this.contractMissions
			 * let stackOfMissions = []
			 * this.contractMissions.map(mission => stackOfMissions.push(new Mission(mission)))
			 */
			//console.log("Missions are updating...", this.contractMissions);
			for (let mission of this.contractMissions) {
				let missionToUpdate = new Mission(mission);
				missionToUpdate.status = 4;
				//console.log(missionToUpdate);
				missionToUpdate.update();
			}
		},

		checkTerminationStatus() {
			this.showStatusValidationPopup =
				this.current_status[0] == 4 ? true : false;
			if (!this.showStatusValidationPopup) this.saveContract();
		},

		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = "";
			switch (name) {
				case "society_id":
				case "early_cancellation_duration":
				case "engagement_duration":
				case "commercial_id":
					value ? (value = String(val)) : "";
					value == null ? (value = "") : "";
					constname = "isNumberConstraint";
					break;
				case "commentary":
				case "detail":
					constname = "commentaryConstraint";
					break;
				default:
					break;
			}
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			if (
				this.validators[name].valid == false &&
				this.validators[name].errText == ""
			) {
				if (name == "society_id" || name == "commercial_id") {
					this.validators[name].errText = "Ce champ ne peut être vide.";
				} else if (
					this.contract.early_cancellation &&
					name == "early_cancellation_duration"
				) {
					this.validators[name].errText = "Ce champ ne peut être vide.";
				}
			}
			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			if (
				this.contract.early_cancellation &&
				name == "early_cancellation_duration" &&
				this.contract.early_cancellation_duration <= 0
			) {
				this.validators[name].errText = "Ce champ doit être supérieur à 0.";
			}
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				switch (name) {
					case "society_id":
					case "commercial_id":
						return "border: 1px solid red !important; border-radius: 0 5px 5px 0; width: auto !important;";
					case "early_cancellation_duration":
					case "engagement_duration":
					case "commentary":
					case "detail":
						return "border: 1px solid red !important; border-radius: 5px;";
					default:
						"";
				}
			} else if (this.validators[name] && this.validators[name].errText == "") {
				switch (name) {
					case "society_id":
					case "commercial_id":
						return "border: 1px solid green !important; border-radius: 0 5px 5px 0; width: auto !important;";
					case "early_cancellation_duration":
					case "engagement_duration":
					case "commentary":
					case "detail":
						return "border: 1px solid green !important; border-radius: 5px;";
					default:
						"";
				}
			} else {
				return "border: none !important; border-radius: none;";
			}
		},

		acceptTaskValidate() {
			this.showValidateTaskTablePopup = false;
			this.saveContract();
		},

		declineTaskValidate() {
			this.showValidateTaskTablePopup = false;
		},

		/**
		 * Send the data to tha API to create the new society
		 * If the form is successfully sent, the society is redirect to Client.vue
		 */
		async saveContract() {
			let returnBool = true;
			this.check = true;
			this.checkPage = false;

			let fields = [
				"society_id",
				"commercial_id",
				"commentary",
				"detail",
				"early_cancellation_duration",
				"engagement_duration",
			];
			for (let i = 0; i < fields.length; i++) {
				let name = "";
				let value = "";
				switch (fields[i]) {
					case "commercial_id":
						value = this.commercialId;
						break;
					/*
					 * case "max_budget":
					 * value ? value = String(value) : "";
					 * name = "priceConstraint";
					 * break;
					 */
					default:
						value = this.contract[fields[i]];
				}
				value == 0 ? (value = "0") : "";
				switch (fields[i]) {
					case "society_id":
					case "early_cancellation_duration":
					case "engagement_duration":
					case "commercial_id":
						value ? (value = String(value)) : "";
						value == null ? (value = "") : "";
						name = "isNumberConstraint";
						break;
					case "commentary":
					case "detail":
						name = "commentaryConstraint";
						break;
					/*
					 * case "max_budget":
					 * value ? value = String(value) : "";
					 * name = "priceConstraint";
					 * break;
					 */
					default:
						"";
				}
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);
				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				) {
					if (fields[i] == "society_id" || fields[i] == "commercial_id") {
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					} else if (
						this.contract.early_cancellation &&
						fields[i] == "early_cancellation_duration"
					) {
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					}
				}
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
				if (
					this.contract.early_cancellation &&
					fields[i] == "early_cancellation_duration" &&
					this.contract.early_cancellation_duration <= 0
				) {
					this.validators[fields[i]].errText =
						"Ce champ doit être supérieur à 0.";
					this.check = false;
				}
				this.$forceUpdate();
			}
			//console.log("Validator", this.validators);

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.checkPage = true;
				let formatedDate = this.contract.start_date.substring(0, 10);
				formatedDate = formatedDate + " 02:00:00";
				this.contract.account_managers = this.accountmanagerList;
				this.contract.commercial_id = this.commercialId;

				let today = new Date(Date.now());
				let formatedEndDate = today.toISOString();
				formatedEndDate = formatedEndDate.substring(0, 10);
				formatedEndDate = formatedEndDate + " 02:00:00";

				for (let account_manager of this.contract.account_managers) {
					if (!account_manager.is_lead) account_manager["is_lead"] = 0;
				}

				this.contract.status = this.current_status[0];
				this.accountmanagerList = this.contract.account_managers;
				if (!this.contract.compare(this.contractOld)) {
					let formated_estimate_link = this.contract.estimate_link;
					let formated_bccgv_link = this.contract.bccgv_link;
					this.$http
						.post(this.apiUrl + "contract/edit", {
							id: this.contractId,
							type: this.contract.type,
							creation_date: this.contract.creation_date.replace(/T|Z/g, " "),
							start_date: formatedDate,
							end_date: formatedEndDate,
							commentary: this.contract.commentary,
							detail: this.contract.detail,
							delivery: this.contract.delivery,
							estimate_link: formated_estimate_link,
							bccgv_link: formated_bccgv_link,
							society_id: this.contract.society_id,
							commercial_id: this.commercialId,
							status: this.current_status[0],
							max_budget: 0,
							users_id: this.activeUser.id,
							early_cancellation: this.contract.early_cancellation,
							early_cancellation_duration:
								this.contract.early_cancellation_duration,
							engagement_duration: this.contract.engagement_duration,
							termination_reason_id: this.current_status[1],
						})
						.then(() => {
							if (this.bccgvToUpdate) {
								//console.log("this.contractId", this.contractId);
								this.$http
									.post(
										this.apiUrl + "contract/updateBccgv/" + this.contractId,
										this.bccgvToUpdate,
										{
											headers: {
												accept: "application/json",
												"Accept-Language": "en-US,en;q=0.8",
												"Content-Type": `multipart/form-data; boundary=${this.bccgvToUpdate._boundary}`,
											},
										}
									)
									.then(() => {
										this.$vs.notify({
											title: "Succès",
											text: "BCCGV uploadé avec succès.",
										});
										if (this.contract.status == 4) this.terminateAllMissions();
										this.contract.updateUserRelation(
											this.contractId,
											this.contractOld.account_managers,
											this.activeUser.id
										);
										this.getContractMission(this.contract.id);

										if (
											this.accountmanagerList.filter(
												(manager) => manager.is_lead == 1
											).length > 0
										) {
											let lead = this.accountmanagerList.filter(
												(manager) => manager.is_lead == 1
											)[0];
											this.$http
												.get(
													this.apiUrl +
														"mission/getmu/contract/list/" +
														this.contractId
												)
												.then((res) => {
													for (let m of this.contractMissions) {
														if (
															res.data.filter(
																(mission) => mission.mission_id == m.id
															).length == 0
														) {
															let tmp = new Mission(m);
															tmp.createAM(
																lead.id,
																this.contractId,
																m.contract_society_id,
																lead,
																m.id,
																(res) => {}
															);
														}
													}
												});
										}

										// Send a success notification to the user
										this.$vs.notify({
											title: "Succès",
											text: "Contrat enregistré avec succès.",
										});
										returnBool = true;
									})
									.catch((err) => {
										//console.log(err);
										this.$vs.notify({
											title: "Echec",
											text: "L'upload des BCCGV a échoué.",
										});
										returnBool = false;
									});
							} else {
								if (this.contract.status == 4) this.terminateAllMissions();
								this.contract.updateUserRelation(
									this.contractId,
									this.contractOld.account_managers,
									this.activeUser.id
								);
								this.getContractMission(this.contract.id);

								if (
									this.accountmanagerList.filter(
										(manager) => manager.is_lead == 1
									).length > 0
								) {
									let lead = this.accountmanagerList.filter(
										(manager) => manager.is_lead == 1
									)[0];

									this.$http
										.get(
											this.apiUrl +
												"mission/getmu/contract/list/" +
												this.contractId
										)
										.then((res) => {
											for (let m of this.contractMissions) {
												if (
													res.data.filter(
														(mission) => mission.mission_id == m.id
													).length == 0
												) {
													let tmp = new Mission(m);
													tmp.createAM(
														lead.id,
														this.contractId,
														m.contract_society_id,
														lead,
														m.id,
														(res) => {}
													);
												}
											}
										});
								}
								// Send a success notification to the user
								this.$vs.notify({
									title: "Succès",
									text: "Contrat enregistré avec succès.",
								});
								returnBool = true;
							}
						})
						.catch((err) => {
							this.$vs.notify({
								title: "Echec",
								text: "Le contrat n'a pas été enregistré.",
							});
							returnBool = false;
						});
				}
				if (returnBool) {
					this.returnPrevRoute();
				}
			}
		},

		showMissionForm() {
			this.clickAddMission = true;
		},

		closeMissionForm(value) {
			this.clickAddMission = value;
		},

		/**
		 * Checks if estimate link is valid
		 */
		checkEstimateLink() {
			this.checkHandler(
				this.contract.estimate_link,
				this.ContractValidationObjects.estimateLinkValidationObject
			);
		},

		/**
		 * Checks if bccgv link is valid
		 */
		checkBcCgv() {
			this.checkHandler(
				this.contract.bccgv_link,
				this.ContractValidationObjects.bccgvValidationObject
			);
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllRequiredFields() {
			let requiredFieldsOk = true;

			Object.entries(this.ContractValidationObjects).forEach((entry) => {
				const [key, value] = entry;
				if (value.required && !value.valid && requiredFieldsOk) {
					requiredFieldsOk = value.valid;
				}
			});

			return requiredFieldsOk;
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllFieldsError() {
			let fieldsErrorOk = true;

			Object.entries(this.ContractValidationObjects).forEach((entry) => {
				const [key, value] = entry;
				if (value.notValid && fieldsErrorOk) {
					fieldsErrorOk = false;
				}
			});

			return fieldsErrorOk;
		},

		refreshData(value) {
			this.getAllProducts();
			this.missionsAdded += value;
			this.clickAddMission = false; // Close the form
		},

		addAccountManager(selectedAccountManager) {
			if (
				selectedAccountManager &&
				this.accountmanagerList.filter(
					(manager) => manager.is_lead && manager.is_lead == 1
				).length < 1
			) {
				let selectedAccountManagerIsPresent = this.accountmanagerList.filter(
					(accountManager) => accountManager.id == selectedAccountManager.id
				);
				if (selectedAccountManagerIsPresent.length <= 0) {
					this.lead_account_manager = selectedAccountManager;
					selectedAccountManager["is_lead"] = 1;
					this.accountmanagerList.push(selectedAccountManager);
				} else {
					this.lead_account_manager = selectedAccountManager;
					for (let manager of this.accountmanagerList) {
						if (manager.id == selectedAccountManager.id) manager["is_lead"] = 1;
					}
				}
				this.refreshList++;
			}
		},

		deleteAccountManager(selectedAccountManager) {
			this.$http
				.get(this.apiUrl + "mission/getmu/contract/list/" + this.contractId)
				.then((res) => {
					if (
						res.data.filter(
							(mission) => mission.users_id == selectedAccountManager
						).length == 0
					)
						this.accountmanagerList = this.accountmanagerList.filter(
							(accountManager) => accountManager.id != selectedAccountManager
						);
					else {
						for (let manager of this.accountmanagerList) {
							if (manager.id == selectedAccountManager) manager.is_lead = 0;
						}
					}
					this.refreshList++;
				});
		},

		deleteAccountManagerLead(selectedAccountManager) {
			//console.log("deleteAccountManagerLead");
			this.accountmanagerList = this.accountmanagerList.filter(
				(accountManager) => accountManager.id != selectedAccountManager
			);
			if (this.accountmanagerList.length > 0)
				this.lead_account_manager = this.accountmanagerList[0];
			else this.lead_account_manager_On = false;
			this.refreshList++;
		},

		showSocietyPopup() {
			//Initialisation des données pour le popup
			this.selectedSociety = null;
			this.selectedSociety = this.societyOptions.find(
				(society) => society.id == this.contract.society_id
			);
			this.showSocietyPopupActive = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractSocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopupActive,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
			//console.log("showSocietyPopup");
		},

		addBccgvToPost() {
			let bccgv = this.$refs.bccgvUp.getFile();
			let formData = new FormData();
			formData.append("bccgv", bccgv.file);
			this.bccgvToUpdate = formData;
		},

		/*
		 * setLeadAccountManager(){
		 *   //console.log(this.lead_account_manager.id)
		 * },
		 */

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			if (this.missionsAdded == 0 && this.checkPage == true) {
				this.$vs.notify({
					title: "Echec",
					text: "Vous devez ajouter au moins une prestation.",
				});
				return false;
			}
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.center_div {
	justify-content: center;
}
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.table_sizing {
	max-width: 800px;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}
</style>
